import { Injectable } from '@angular/core';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { TypeEnum } from '@modules/order/models/type.enum';
import { ProcedureConfigurationService } from '@modules/order/services/procedure-configuration.service';
import { OrderQuery } from '@modules/order/state/order-query';
import { SoftwareOptions } from '@shared/models/enums/enums';
import { IdName } from '@shared/models/id-name';
import { RxComponents } from '@shared/models/rx-models/interfaces/rx-components-model';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { enumEquals } from '@shared/utils/enum-utils';
import { combineLatest, map, Observable, shareReplay } from 'rxjs';
import { SoftwareOptionsService } from './software-options.service';

@Injectable({
	providedIn: 'root'
})
export class OrthoModelICastService {
	isOrthoModelICastVisible$: Observable<boolean> = this.orderQuery.procedureMap$.pipe(
		map(procedureMap => !!procedureMap && enumEquals(procedureMap.ProcedureId, ProcedureEnum.StudyModel_iRecord))
	);

	orthoModelICastValue$: Observable<IdName | null> = this.procedureConfigurationService.types$.pipe(
		map(types => (types.length > 0 ? types[0] : null))
	);

	isOrthoModelICastToggleChecked$: Observable<boolean> = combineLatest([this.orthoModelICastValue$, this.orderQuery.procedureMap$]).pipe(
		map(
			([orthoModelICastValue, procedureMap]) =>
				!!orthoModelICastValue && !!procedureMap && orthoModelICastValue.Id === procedureMap.TypeId
		)
	);

	isOrthoModelICastEnabled$: Observable<boolean> = this.softwareOptionsService.hasScannerSoftwareOption$(SoftwareOptions.OrthoModelICast);

	isStudyModelIRecordEnabled$: Observable<boolean> = this.orderQuery.availableProcedureMaps$.pipe(
		map(
			procedureMaps =>
				procedureMaps?.some(
					pm =>
						(pm.ProcedureId as ProcedureEnum) === ProcedureEnum.StudyModel_iRecord && (pm.TypeId as TypeEnum) === TypeEnum.Empty
				) ?? false
		)
	);

	constructor(
		private readonly shellQuery: ShellQuery,
		private readonly orderQuery: OrderQuery,
		private readonly procedureConfigurationService: ProcedureConfigurationService,
		private readonly softwareOptionsService: SoftwareOptionsService
	) {}

	isOrthoModelICastToggleDisabled(section: keyof RxComponents): Observable<boolean> {
		return combineLatest([
			this.shellQuery.getReadOnlyState(section),
			this.shellQuery.isReturned$,
			this.isOrthoModelICastEnabled$,
			this.isStudyModelIRecordEnabled$
		]).pipe(
			map(
				([isReadOnly, isReturned, isOrthoModelIcastEnabled, isStudyModelIRecordEnabled]) =>
					!isOrthoModelIcastEnabled || !isStudyModelIRecordEnabled || isReadOnly || isReturned
			),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}
}
